// modal処理

// 開く
let modal = document.getElementById('kojinjoho___modal');
let openTrigger = document.querySelectorAll('a[data-modal]');
let closeTrigger = document.querySelector('#kojinjoho___modal_close_button');
const speed = 300;    // フェードスピード

g_Arr(openTrigger).forEach(function(trigger) {
  trigger.addEventListener('click', function() {
    modalOpen(this);
  });
});

closeTrigger.addEventListener('click', function() {
  modalClose();
});

modal.addEventListener('click', function(e) {
  if($(e.target).closest('.kojinjoho___modal_wrapper').length < 1) {
    modalClose();
  }
});



// ----------------------------------
// modalを表示する
// ----------------------------------
function modalOpen(elem) {
  let modalNum = elem.getAttribute('data-modal');
  // 一旦全て非表示
  let contents = document.querySelectorAll('.kojinjoho___modal_content');
  g_Arr(contents).forEach(function(content) {
    content.style.display = 'none';
  });

  // 選択された方のみ表示
  let selectedContent = document.querySelector('.kojinjoho___modal_content.kojinjoho___modal_' + modalNum);
  selectedContent.style.display = '';

  // modal自体をフェードイン
  $(modal).fadeIn(speed);
}

// ----------------------------------
// modalを閉じる
// ----------------------------------
function modalClose() {
  $(modal).fadeOut(speed);
}